export default __webpack_public_path__ + "static/media/button-menu.0711cf56.svg";